import React from "react";
import { RODEO_PAGE_NAME } from "src/_config";
import Sidebar from "src/components/common/Sidebar";
const LazyRodeoDetailsListing = React.lazy(() => import("src/components/rodeo-details-listing/RodeoDetailsListing"));

export default function RodeoDetailsListingContainer(props: Record<string, any>) {
  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.RODEO_DETAILS_LISTING} />
      <React.Suspense fallback={null}>
        <LazyRodeoDetailsListing {...props} />
      </React.Suspense>
    </React.Fragment>
  );
}
